'use client';

import {
    trackProductTileClick,
    createItemsViewEvent,
    trackProductTileItemClick,
    TrackingParams,
    trackContentfulClick,
} from '@libs/analytics';
import type { Product } from '@libs/analytics';
import { getDefaultCategories } from '@libs/algolia';
import { HorizontalOverflowCarouselItem } from '@petsmart-ui/sparky';
import { usePathname, useSearchParams } from 'next/navigation';
import type { ProductTrackerProps } from './types';

export function ProductTracker({ children, headline, variant, position, product }: ProductTrackerProps) {
    const params = useSearchParams();
    const pathname = usePathname();
    const searchWord = params?.get('q');

    return (
        <HorizontalOverflowCarouselItem
            data-testid={product.title}
            onClick={() => {
                window.sessionStorage.setItem('pdpFindingMethod', TrackingParams.CONTENTFUL_REFERER);
                trackProductTileItemClick({
                    product: product as unknown as Product,
                    ...createItemsViewEvent(
                        [product],
                        headline ?? '',
                        'product carousel',
                        getDefaultCategories(product).map(p => p.name.default),
                        decodeURIComponent(searchWord || '')
                    ),
                });

                trackProductTileClick({
                    list: 'Product carousel',
                    product,
                    variant,
                    position,
                });
                trackContentfulClick({
                    position,
                    linkText: product.title ?? '',
                    linkUrl: product.href ?? '',
                    promoTitle: headline ?? '',
                    promoVariant: variant,
                    promoDesc: 'sparky-c-product-card',
                    promoType: `product-carousel - ${variant}`,
                    promoOrigin: pathname,
                });
            }}
        >
            {children}
        </HorizontalOverflowCarouselItem>
    );
}
